import { Badge } from 'src/components/ui/badge';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from 'src/components/ui/hover-card';
import { useAttributionForAddress } from 'src/hooks/attributions/useAttributionForAddress';
import { InfoIcon } from 'lucide-react';
import { useAddressAndChainParams } from 'src/hooks/routing/useAddressAndChainParams';
import { LockedAttributionHoverCard } from 'src/components/Attribution/LockedAttributionHoverCard';

export const BeneficialOwner = () => {
  const { address, chain } = useAddressAndChainParams();
  const { attribution } = useAttributionForAddress(chain, address);
  const beneficialOwner = attribution?.beneficial_owner;

  if (!beneficialOwner || beneficialOwner === attribution.entity) return null;

  return (
    <div className="mt-2 flex flex-row flex-wrap items-center py-2">
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-muted-foreground">
          Beneficial Owner:
        </span>
        <LockedAttributionHoverCard
          attributionValue={beneficialOwner}
          attributionType="beneficial_owner"
          iconSize="sm"
          triggerClassName="text-sm"
          fallback={<Badge variant="primary">{beneficialOwner}</Badge>}
        />
        <HoverCard openDelay={0} closeDelay={100}>
          <HoverCardTrigger>
            <InfoIcon className="size-4 text-muted-foreground/70 hover:text-muted-foreground/90" />
          </HoverCardTrigger>
          <HoverCardContent className="w-80" side="top" align="end">
            <div className="flex flex-col gap-3">
              <div className="flex flex-col gap-1.5">
                <h4 className="font-medium leading-none">
                  What is a Beneficial Owner?
                </h4>
                <p className="text-sm text-muted-foreground">
                  The beneficial owner is the actual owner of the funds in this
                  address, even if another service manages it for them.
                </p>
              </div>
              <div className="rounded-md bg-muted/50 p-3">
                <p className="text-xs text-muted-foreground">
                  For example: When you keep your Bitcoin on Binance, the
                  address belongs to Binance (the entity), but you are the
                  beneficial owner of those funds.
                </p>
              </div>
            </div>
          </HoverCardContent>
        </HoverCard>
      </div>
    </div>
  );
};
